// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '5.0.1'
export const publishDates = {
	major: '2026-05-06T16:21:11.305Z',
	minor: '2026-05-06T16:21:11.305Z',
	patch: '2026-05-15T16:56:01.359Z',
}
